import React from 'react';

const WhatsAppButton = () => {
  const handleWhatsAppClick = () => {
    // WhatsApp numbers from the website
    const phoneNumber = '919972235566'; // Primary number without + and spaces
    const message = encodeURIComponent('Hello! I would like to know more about your workspace solutions at Laksh Space.');
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
    
    // Open in new tab
    window.open(whatsappUrl, '_blank');
  };

  return (
    <button
      onClick={handleWhatsAppClick}
      className="fixed bottom-24 right-6 z-50 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-110 group"
      title="Chat on WhatsApp"
    >
     <svg viewBox="0 0 32 32" className="h-8 w-8" fill="white" aria-hidden="true">
       <path d="M16.001 3C9.096 3 3.5 8.596 3.5 15.5c0 2.34.64 4.53 1.756 6.41L3 29l7.27-2.208A12.44 12.44 0 0 0 16.001 28C22.906 28 28.5 22.404 28.5 15.5S22.906 3 16.001 3Zm7.29 17.61c-.31.87-1.53 1.6-2.51 1.81-.67.14-1.54.25-4.48-.96-3.76-1.56-6.18-5.38-6.37-5.63-.19-.25-1.52-2.02-1.52-3.86 0-1.84.96-2.74 1.31-3.11.31-.34.71-.42.95-.42h.68c.22 0 .51-.08.8.61.31.75 1.06 2.59 1.15 2.78.09.19.15.41.03.66-.12.25-.18.41-.36.63-.19.22-.39.5-.56.67-.19.19-.38.4-.16.78.22.38.98 1.62 2.11 2.63 1.45 1.29 2.67 1.7 3.05 1.89.38.19.6.16.83-.09.24-.25 1-1.17 1.27-1.57.27-.4.53-.33.89-.2.36.13 2.31 1.09 2.71 1.29.4.19.66.29.76.45.1.16.1.94-.2 1.81Z"/>
     </svg>
      
      {/* Pulse effect */}
      <div className="absolute inset-0 bg-green-500 rounded-full animate-ping opacity-20"></div>
      
      {/* Tooltip */}
      <div className="absolute bottom-full right-0 mb-2 px-3 py-1 bg-gray-900 text-white text-sm rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
        Chat on WhatsApp
        <div className="absolute top-full right-4 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900"></div>
      </div>
    </button>
  );
};

export default WhatsAppButton;